var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaterBottle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M18.2,37.3h8.6c1.3,0,2.3-1,2.3-2.3v-3.8c0-0.7-0.3-1.4-0.9-1.9c0.6-0.4,0.9-1,0.9-1.7 c0-0.7-0.3-1.3-0.9-1.7c0.6-0.4,0.9-1,0.9-1.7c0-0.7-0.3-1.3-0.9-1.7c0.6-0.5,0.9-1.2,0.9-1.9v-4.4l-3.9-5.2h0.9V7.6h-7.2v3.4h0.9 l-3.9,5.2v4.4c0,0.8,0.4,1.5,1,1.9c-0.6,0.3-1,1-1,1.7c0,0.7,0.3,1.3,0.9,1.7c-0.6,0.4-0.9,1-0.9,1.7c0,0.7,0.4,1.4,1,1.7 c-0.6,0.4-1,1.1-1,1.9v3.8C15.9,36.3,16.9,37.3,18.2,37.3z M19.6,10.3V8.4h5.8v1.9h-0.7h-4.3H19.6z M16.6,20.6v-4.2l4.1-5.4h3.6 l4.1,5.4v4.2c0,0.9-0.7,1.6-1.6,1.6h-8.6C17.3,22.3,16.6,21.5,16.6,20.6z M16.6,24.3c0-0.7,0.6-1.3,1.3-1.3h9.2 c0.7,0,1.3,0.6,1.3,1.3c0,0.7-0.6,1.3-1.3,1.3h-9.2C17.2,25.6,16.6,25,16.6,24.3z M16.6,27.6c0-0.7,0.6-1.3,1.3-1.3h9.2 c0.7,0,1.3,0.6,1.3,1.3s-0.6,1.3-1.3,1.3h-9.2C17.2,28.9,16.6,28.4,16.6,27.6z M16.6,31.3c0-0.8,0.6-1.5,1.4-1.6h9 c0.8,0.1,1.4,0.8,1.4,1.6v3.8c0,0.9-0.7,1.6-1.6,1.6h-8.6c-0.9,0-1.6-0.7-1.6-1.6V31.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#C9C9C9",
    points: "24.7,10.3 25.4,10.3 25.4,8.4 19.6,8.4 19.6,10.3 20.4,10.3  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M18.2,22.3h8.6c0.9,0,1.6-0.7,1.6-1.6v-4.2l-4.1-5.4h-3.6l-4.1,5.4v4.2C16.6,21.5,17.3,22.3,18.2,22.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M17.9,28.9h9.2c0.7,0,1.3-0.6,1.3-1.3s-0.6-1.3-1.3-1.3h-9.2c-0.7,0-1.3,0.6-1.3,1.3S17.2,28.9,17.9,28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M17.9,25.6h9.2c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3h-9.2c-0.7,0-1.3,0.6-1.3,1.3 C16.6,25,17.2,25.6,17.9,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M18.2,36.6h8.6c0.9,0,1.6-0.7,1.6-1.6v-3.8c0-0.8-0.6-1.5-1.4-1.6h-9c-0.8,0.1-1.4,0.8-1.4,1.6v3.8 C16.6,35.9,17.3,36.6,18.2,36.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterBottle);
export default __webpack_public_path__ + "static/media/water_bottle.11834028c5912c270bdc8fd6e319c0bc.svg";
export { ForwardRef as ReactComponent };